import InboxIcon from '@mui/icons-material/Inbox'
import { Typography, IconButton } from '@mui/material'
import React from 'react'
import { StyledChevronLeftIcon } from '../ConversationsList/ConversationChat/styles'
import { CustomerResponse } from 'api/ovation/models'
import {
  CustomerInfoContainer,
  CustomerInfoList,
  InfoLabel,
  InfoValue,
  CustomerInfoRow,
  CenteredBox,
  StyledHeading,
  MobileBackBox,
} from './styles';

interface CustomerInfoSectionProps {
  customerInfo: CustomerResponse | null;
  onBack: () => void;
}
const RatingToEmoji = ['🤬','😡','🙁','😐','🙂','🤩']

const CustomerInfoSection: React.FC<CustomerInfoSectionProps> = ({ customerInfo, onBack }) => {
  const averageSatisfaction = customerInfo?.data?.metrics?.average_satisfaction

  const infoToDisplay = customerInfo?.data?.customer ?  {
    Name: customerInfo.data.customer.name,
    Email: customerInfo.data.customer.email,
    Phone: customerInfo.data.customer.phone,
    'Avg Satisfaction': averageSatisfaction ? `${RatingToEmoji[Math.floor(averageSatisfaction)]}(${averageSatisfaction})` : 'N/A',
    } : {}

  return (
    <>
      <StyledHeading variant='h6'>
        <MobileBackBox>
          <IconButton size="small" onClick={onBack}>
            <StyledChevronLeftIcon />
          </IconButton>
        </MobileBackBox>
        Customer Info
      </StyledHeading>
      <CustomerInfoContainer>
        {Object.entries(infoToDisplay).length ? (
          <CustomerInfoList>
            {Object.entries(infoToDisplay).map(([label, value], index) => (
              <CustomerInfoRow key={index}>
                <InfoLabel>{label}</InfoLabel>
                <InfoValue>{value}</InfoValue>
              </CustomerInfoRow>
            ))}
          </CustomerInfoList>
        ) : (
          <CenteredBox>
            <InboxIcon sx={{ fontSize: 40, marginBottom: 1 }} />
            <Typography variant='body1'>No conversation selected</Typography>
          </CenteredBox>
        )}
      </CustomerInfoContainer>
    </>
  )
}

export default CustomerInfoSection;
